import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const timeAgo = (ts: string) => {
  const parsed = Date.parse(ts);
  if (Number.isNaN(parsed)) return '—';
  const diff = Math.max(0, Date.now() - parsed);
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 30) return `${days}d ago`;
  return new Date(parsed).toLocaleDateString();
};

export function daysSince(dateStr?: string) {
  if (!dateStr) return 0;
  const parsed = Date.parse(dateStr);
  if (Number.isNaN(parsed)) return 0;
  return Math.floor(Math.max(0, Date.now() - parsed) / 86400000);
}
